import { Component, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
@Component({
  selector: "app-modal-header-common",
  templateUrl: "./modal-header-common.component.html",
  styleUrls: ["./modal-header-common.component.scss"],
})
export class ModalHeaderCommonComponent {
  @Input() title: any;
  @Input() dialogRef!: MatDialogRef<any>;

  constructor(
  ) {}

  onCloseClick() {
    console.log(this.dialogRef);
    this.dialogRef.close();
  }
}
